var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _ellipse, _path42, _path43, _ellipse2, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _ellipse3, _path87, _path88, _path89, _path90, _rect, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _ellipse4, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgAboutSc = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 416 260",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__a",
    x1: "0%",
    x2: "100%",
    y1: "50%",
    y2: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#DFE6FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "12%",
    stopColor: "#E4EAFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "64%",
    stopColor: "#F7F9FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FEFEFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__b",
    x1: "0%",
    x2: "100%",
    y1: "50%",
    y2: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#DFE6FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "12%",
    stopColor: "#E4EAFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "64%",
    stopColor: "#F7F9FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FEFEFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__c",
    x1: "0%",
    x2: "100%",
    y1: "50%",
    y2: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#BFC9DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#BFC9DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "30%",
    stopColor: "#D0D9EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#DAE2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#DDE5FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__d",
    x1: "0%",
    x2: "100%",
    y1: "50.011%",
    y2: "50.011%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#BFC9DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#BFC9DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "30%",
    stopColor: "#D0D9EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#DAE2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#DDE5FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__e",
    x1: "0%",
    x2: "100%",
    y1: "50.011%",
    y2: "50.011%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#BFC9DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#BFC9DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "30%",
    stopColor: "#D0D9EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#DAE2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#DDE5FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__f",
    x1: "50.003%",
    x2: "50.003%",
    y1: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#DDE5FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "37%",
    stopColor: "#E0E8FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "68%",
    stopColor: "#EBEFFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "96%",
    stopColor: "#FCFDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__g",
    x1: "50%",
    x2: "50%",
    y1: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#BFC9DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#BFC9DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "30%",
    stopColor: "#D0D9EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#DAE2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#DDE5FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__h",
    x1: "0%",
    x2: "100%",
    y1: "50%",
    y2: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#BFC9DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#BFC9DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "30%",
    stopColor: "#D0D9EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#DAE2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#DDE5FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__i",
    x1: "0%",
    x2: "100%",
    y1: "50%",
    y2: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#DDE5FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__j",
    x1: "50%",
    x2: "50%",
    y1: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#BFC9DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#BFC9DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "30%",
    stopColor: "#D0D9EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#DAE2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#DDE5FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__k",
    x1: "50%",
    x2: "50%",
    y1: "100.013%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#DDE5FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "38%",
    stopColor: "#DAE2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "70%",
    stopColor: "#D0D9EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#BFC9DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#BFC9DD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__l",
    x1: "50%",
    x2: "50%",
    y1: "100.009%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#BFC9DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#BFC9DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "30%",
    stopColor: "#D0D9EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#DAE2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#DDE5FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__m",
    x1: "0%",
    x2: "100%",
    y1: "49.991%",
    y2: "49.991%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#BFC9DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#BFC9DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "30%",
    stopColor: "#D0D9EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#DAE2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#DDE5FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__n",
    x1: "0%",
    x2: "100%",
    y1: "50%",
    y2: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#BFC9DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#BFC9DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "30%",
    stopColor: "#D0D9EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#DAE2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#DDE5FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__o",
    x1: "-.033%",
    x2: "100%",
    y1: "50%",
    y2: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#BFC9DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#BFC9DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "30%",
    stopColor: "#D0D9EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#DAE2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#DDE5FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__p",
    x1: "100.011%",
    x2: ".002%",
    y1: "50.034%",
    y2: "50.034%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#BFC9DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#BFC9DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "30%",
    stopColor: "#D0D9EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#DAE2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#DDE5FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__q",
    x1: "0%",
    x2: "100%",
    y1: "50.016%",
    y2: "50.016%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#DDE5FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__r",
    x1: "100%",
    x2: "0%",
    y1: "50.007%",
    y2: "50.007%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#DDE5FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__s",
    x1: "100.025%",
    x2: ".044%",
    y1: "50.082%",
    y2: "50.082%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#BFC9DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#BFC9DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "30%",
    stopColor: "#D0D9EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#DAE2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#DDE5FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__t",
    x1: "100.011%",
    x2: "0%",
    y1: "50.004%",
    y2: "50.004%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#BFC9DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#BFC9DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "30%",
    stopColor: "#D0D9EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#DAE2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#DDE5FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__u",
    x1: "0%",
    x2: "100%",
    y1: "50.005%",
    y2: "50.005%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#DDE5FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__v",
    x1: "50%",
    x2: "50%",
    y1: "100.016%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#BFC9DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#BFC9DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "30%",
    stopColor: "#D0D9EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#DAE2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#DDE5FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__w",
    x1: "50%",
    x2: "50%",
    y1: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#DDE5FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "38%",
    stopColor: "#DAE2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "70%",
    stopColor: "#D0D9EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#BFC9DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#BFC9DD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__x",
    x1: "50%",
    x2: "50%",
    y1: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#BFC9DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#BFC9DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "30%",
    stopColor: "#D0D9EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#DAE2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#DDE5FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__y",
    x1: "0%",
    x2: "100%",
    y1: "50%",
    y2: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#BFC9DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#BFC9DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "30%",
    stopColor: "#D0D9EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#DAE2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#DDE5FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__z",
    x1: "0%",
    x2: "100%",
    y1: "50.005%",
    y2: "50.005%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#BFC9DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#BFC9DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "30%",
    stopColor: "#D0D9EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#DAE2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#DDE5FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__A",
    x1: "99.927%",
    x2: "-.011%",
    y1: "50.043%",
    y2: "50.043%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#BFC9DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#BFC9DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "30%",
    stopColor: "#D0D9EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#DAE2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#DDE5FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__B",
    x1: "0%",
    x2: "100%",
    y1: "49.984%",
    y2: "49.984%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#DDE5FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__C",
    x1: "-982.459%",
    x2: "-882.459%",
    y1: "50.015%",
    y2: "50.015%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#DDE5FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__D",
    x1: "100.025%",
    x2: "-.034%",
    y1: "50%",
    y2: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#BFC9DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#BFC9DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "30%",
    stopColor: "#D0D9EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#DAE2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#DDE5FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__E",
    x1: "100%",
    x2: ".011%",
    y1: "50%",
    y2: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#BFC9DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#BFC9DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "30%",
    stopColor: "#D0D9EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#DAE2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#DDE5FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__F",
    x1: "100%",
    x2: "-.005%",
    y1: "49.996%",
    y2: "49.996%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "4%",
    stopColor: "#FCFDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "32%",
    stopColor: "#EBEFFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "63%",
    stopColor: "#E0E8FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#DDE5FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__G",
    x1: "100%",
    x2: "-.005%",
    y1: "49.997%",
    y2: "49.997%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#DDE5FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "37%",
    stopColor: "#E0E8FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "68%",
    stopColor: "#EBEFFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "96%",
    stopColor: "#FCFDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__H",
    x1: "100%",
    x2: "-.005%",
    y1: "50%",
    y2: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#DDE5FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "37%",
    stopColor: "#E0E8FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "68%",
    stopColor: "#EBEFFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "96%",
    stopColor: "#FCFDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__I",
    x1: "2004.969%",
    x2: "2104.969%",
    y1: "50%",
    y2: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "4%",
    stopColor: "#FCFDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "32%",
    stopColor: "#EBEFFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "63%",
    stopColor: "#E0E8FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#DDE5FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__J",
    x1: "0%",
    x2: "100%",
    y1: "50%",
    y2: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#DDE5FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "37%",
    stopColor: "#E0E8FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "68%",
    stopColor: "#EBEFFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "96%",
    stopColor: "#FCFDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__K",
    x1: "0%",
    x2: "100%",
    y1: "50.013%",
    y2: "50.013%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#BFC9DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#BFC9DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "30%",
    stopColor: "#D0D9EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#DAE2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#DDE5FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__L",
    x1: "100.01%",
    x2: "0%",
    y1: "49.996%",
    y2: "49.996%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#DDE5FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "38%",
    stopColor: "#DAE2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "70%",
    stopColor: "#D0D9EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#BFC9DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#BFC9DD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__M",
    x1: "100%",
    x2: ".014%",
    y1: "49.996%",
    y2: "49.996%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#DDE5FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__N",
    x1: "100.006%",
    x2: ".006%",
    y1: "50%",
    y2: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "4%",
    stopColor: "#FCFDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "32%",
    stopColor: "#EBEFFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "63%",
    stopColor: "#E0E8FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#DDE5FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__O",
    x1: "50.014%",
    x2: "50.014%",
    y1: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#DDE5FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "38%",
    stopColor: "#DAE2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "70%",
    stopColor: "#D0D9EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#BFC9DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#BFC9DD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__P",
    x1: "50%",
    x2: "50%",
    y1: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#DDE5FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "37%",
    stopColor: "#E0E8FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "68%",
    stopColor: "#EBEFFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "96%",
    stopColor: "#FCFDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__Q",
    x1: "100%",
    x2: ".006%",
    y1: "50%",
    y2: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "4%",
    stopColor: "#FCFDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "32%",
    stopColor: "#EBEFFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "63%",
    stopColor: "#E0E8FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#DDE5FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__R",
    x1: "50%",
    x2: "50%",
    y1: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#DDE5FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "38%",
    stopColor: "#DAE2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "70%",
    stopColor: "#D0D9EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#BFC9DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#BFC9DD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__S",
    x1: "0%",
    x2: "100%",
    y1: "50%",
    y2: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#BFC9DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#BFC9DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "30%",
    stopColor: "#D0D9EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#DAE2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#DDE5FC"
  })))), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#BFC9DD",
    fillRule: "nonzero",
    opacity: 0.3,
    style: {
      mixBlendMode: "multiply"
    },
    d: "M123.642 259.934L165.893 259.934 219.248 229.128 197.517 217.253zM290.945 257.394L333.196 257.394 415.714 210.04 375.3 187.958 375.3 209.195z"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0C53FA",
    fillRule: "nonzero",
    d: "M0.277 0.262L0.277 93.82 195.873 200.862 195.873 107.566z",
    opacity: 0.3,
    transform: "translate(179.427)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#9BB3FB",
    fillRule: "nonzero",
    d: "M179.703 93.82L1.18 195.843 101.226 251.601 123.817 251.601 197.517 208.921 268.335 249.122 290.927 249.122 375.3 201.124z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#0C53FA",
    fillRule: "nonzero",
    d: "M178.782 0.262L178.782 93.82 0.258 195.843 0.258 102.285z",
    opacity: 0.2,
    transform: "translate(.922)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#F0F3FD",
    fillRule: "nonzero",
    d: "M101.226 251.601H123.642V259.934H101.226z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#C0C9DD",
    fillRule: "nonzero",
    d: "M197.517 217.253L123.642 259.934 123.642 251.601 197.517 208.921zM375.3 209.195L290.945 257.394 290.945 249.061 375.3 200.862z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#prefix__a)",
    fillRule: "nonzero",
    d: "M101.226 259.934L1.18 204.175 1.18 195.843 101.226 251.601z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#prefix__b)",
    fillRule: "nonzero",
    d: "M268.529 257.394L197.517 217.253 197.517 208.921 268.529 249.061z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#F0F3FD",
    fillRule: "nonzero",
    d: "M268.529 249.061H290.945V257.394H268.529z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#prefix__c)",
    fillRule: "nonzero",
    d: "M193.203 103.883L181.427 97.196 181.427 96.438 193.203 89.859z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#FBFCFF",
    fillRule: "nonzero",
    d: "M181.427 110.458L181.427 97.196 193.203 103.883z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#prefix__d)",
    fillRule: "nonzero",
    d: "M179.891 111.216L168.117 104.533 168.117 103.771 179.891 97.196z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#FBFCFF",
    fillRule: "nonzero",
    d: "M168.117 117.794L168.117 104.533 179.891 111.216z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#prefix__d)",
    fillRule: "nonzero",
    d: "M166.932 118.553L155.158 111.869 155.158 111.108 166.932 104.533z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#FBFCFF",
    fillRule: "nonzero",
    d: "M155.158 125.131L155.158 111.869 166.932 118.553z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#prefix__e)",
    fillRule: "nonzero",
    d: "M153.797 125.889L142.021 119.206 142.021 118.444 153.797 111.869z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#FBFCFF",
    fillRule: "nonzero",
    d: "M142.021 132.468L142.021 119.206 153.797 125.889zM140.672 104.193L194.564 74.094 180.662 66.396 126.772 96.495z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#prefix__f)",
    fillRule: "nonzero",
    d: "M140.66 104.262v30.466l1.36-.762v-.078l52.538-29.328V74.094l-53.892 30.093v.063l-.006.012zm26.272.761l-11.777 6.578v-14.02l11.773-6.578.004 14.02zm1.36-14.781l11.774-6.585v14.024l-11.773 6.575V90.242zm-14.495 22.115l-11.776 6.578v-14.023l11.776-6.575v14.02zm39.406-22.007l-11.776 6.578v-14.02l11.776-6.578v14.02zm-11.776 20.05V98.404l11.776-6.575v11.991l-11.776 6.582zm-13.134 7.337V105.74l11.773-6.575v12.001l-11.773 6.572zm-13.138 7.34v-12.001l11.773-6.575v12l-11.773 6.576zm-13.134 7.33v-11.995l11.776-6.575v12.001l-11.776 6.57z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#prefix__c)",
    fillRule: "nonzero",
    d: "M193.203 90.353L181.427 83.666 181.427 82.908 193.203 76.33z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#FBFCFF",
    fillRule: "nonzero",
    d: "M181.427 96.928L181.427 83.666 193.203 90.353z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#prefix__g)",
    fillRule: "nonzero",
    d: "M140.672 104.193L140.66 134.728 126.772 126.958 126.772 96.495z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#prefix__h)",
    fillRule: "nonzero",
    d: "M179.891 97.69L168.117 91.003 168.117 90.245 179.891 83.666z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#FBFCFF",
    fillRule: "nonzero",
    d: "M168.117 104.265L168.117 91.003 179.891 97.69z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#prefix__d)",
    fillRule: "nonzero",
    d: "M166.932 105.023L155.158 98.34 155.158 97.578 166.932 91.003z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#FBFCFF",
    fillRule: "nonzero",
    d: "M155.158 111.601L155.158 98.34 166.932 105.023z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#prefix__e)",
    fillRule: "nonzero",
    d: "M153.797 112.36L142.021 105.676 142.021 104.915 153.797 98.34z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#FBFCFF",
    fillRule: "nonzero",
    d: "M142.021 118.938L142.021 105.676 153.797 112.36zM136.816 135.79L113.884 121.409 117.598 119.441 140.531 133.822z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#prefix__i)",
    fillRule: "nonzero",
    d: "M136.745 152.97L136.745 135.784 113.884 121.409 113.884 138.622z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#prefix__j)",
    fillRule: "nonzero",
    d: "M140.531 133.822L140.531 150.695 136.745 152.97 136.745 135.784z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#FBFCFF",
    fillRule: "nonzero",
    d: "M91.185 122.155L87.4 119.766 110.827 108.141 114.612 110.53z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#prefix__k)",
    fillRule: "nonzero",
    d: "M93.237 143.743L91.114 122.149 87.4 119.766 89.52 141.39z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#prefix__l)",
    fillRule: "nonzero",
    d: "M114.612 110.53L116.732 131.815 93.237 143.743 91.114 122.149z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "#F2F3F4",
    fillRule: "nonzero",
    d: "M113.251 161.287L93.225 148.657 93.225 143.743 113.251 156.367z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "#FBFCFF",
    fillRule: "nonzero",
    d: "M113.251 156.367L93.225 143.734 116.732 131.815 136.761 144.444z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#prefix__m)",
    fillRule: "nonzero",
    d: "M136.761 149.359L113.251 161.281 113.251 156.367 136.761 144.444z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "#FBFCFF",
    fillRule: "nonzero",
    d: "M109.533 149.972L86.604 135.591 90.319 133.623 113.251 148.004z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#prefix__n)",
    fillRule: "nonzero",
    d: "M109.466 167.152L109.466 149.966 86.604 135.591 86.604 152.804z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#prefix__j)",
    fillRule: "nonzero",
    d: "M113.251 148.004L113.251 164.877 109.466 167.152 109.466 149.966z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "#0C53FA",
    fillRule: "nonzero",
    d: "M24.671 30.032L0.089 15.037 28.447 0.12 52.104 14.556z",
    opacity: 0.4,
    transform: "translate(51.309 155.88)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    d: "M75.814 174.203L75.974 185.768M51.232 160.457L51.389 170.769M102.998 160.072L102.882 170.49"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "#FBFCFF",
    fillRule: "nonzero",
    d: "M75.814 175.452L51.232 160.457 79.175 144.745 103.413 159.924z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "#0C53FA",
    fillRule: "nonzero",
    d: "M89.901 164.035L83.105 159.888 90.829 155.546 97.53 159.744z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 75.974,
    cy: 158.447,
    fill: "url(#prefix__o)",
    fillRule: "nonzero",
    rx: 4.701,
    ry: 2.898
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    stroke: "#6A8AEB",
    strokeLinecap: "round",
    strokeWidth: 0.75,
    d: "M75.974 149.912L75.974 157.742"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "#4ACEA5",
    fillRule: "nonzero",
    d: "M80.675 136.386h-9.396l-3.656 9.63s1.229 4.18 8.36 4.69c7.137-.51 8.357-4.69 8.357-4.69l-3.665-9.63z"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 75.974,
    cy: 136.386,
    fill: "#38AF87",
    fillRule: "nonzero",
    rx: 4.722,
    ry: 2.913
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "#0C53FA",
    fillRule: "nonzero",
    d: "M0.114 17.55L49.398 45.488 80.736 28.209 31.452 0.268z",
    opacity: 0.4,
    transform: "translate(233.194 143.24)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "#FBFCFF",
    fillRule: "nonzero",
    d: "M233.307 138.953L282.591 166.894 313.929 149.611 264.645 121.67z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeLinecap: "round",
    d: "M313.929 149.611L313.929 170.818M282.84 166.957L282.84 188.163M233.307 138.965L233.307 160.171"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#prefix__p)",
    fillRule: "nonzero",
    d: "M271.798 141.923l8.056 4.568c.468.258 1.04.258 1.508 0l4.523-2.492c.18-.1.29-.287.29-.489s-.11-.389-.29-.489l-8.056-4.568c-.467-.262-1.041-.262-1.509 0l-4.519 2.495c-.178.1-.288.285-.29.486 0 .201.11.388.287.489z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#prefix__q)",
    fillRule: "nonzero",
    d: "M277.847 134.267L283.332 137.496 283.332 143.509 277.847 140.28z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "#6A8AEB",
    fillRule: "nonzero",
    d: "M267.825 126.807v-16.482c.002-.745.619-1.349 1.38-1.35.246 0 .487.065.697.189l21.412 12.41c1.261.735 2.036 2.065 2.04 3.503v16.527l-25.529-14.797z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M269.205 109.125c.216.002.428.06.614.168l21.412 12.395c1.214.708 1.96 1.99 1.963 3.374v16.25l-25.221-14.601v-16.386c0-.664.55-1.203 1.229-1.203m0-.301c-.849 0-1.536.673-1.536 1.504v16.57l25.623 14.841.218.072v-16.746c.002-1.492-.802-2.874-2.113-3.632l-21.412-12.396c-.235-.136-.504-.209-.777-.21l-.003-.003z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#prefix__r)",
    fillRule: "nonzero",
    d: "M291.197 145.365l-21.411-12.395c-1.311-.758-2.115-2.138-2.114-3.629v-1.77l25.617 14.83.218.072v1.601c-.003.538-.298 1.032-.775 1.299-.476.266-1.061.263-1.535-.008z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#prefix__s)",
    fillRule: "nonzero",
    d: "M260.098 145.681l12.502 7.19c.467.261 1.041.261 1.508 0l4.52-2.492c.18-.1.29-.287.29-.49 0-.202-.11-.388-.29-.488l-12.502-7.195c-.467-.263-1.041-.263-1.508 0l-4.523 2.491c-.182.1-.295.289-.294.493 0 .205.115.393.297.491z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fill: "#0C53FA",
    fillRule: "nonzero",
    d: "M248.878 135.814l4.203 2.299c.469.26 1.043.26 1.512 0l7.751-4.177c.18-.1.29-.287.29-.489s-.11-.389-.29-.489l-4.206-2.299c-.467-.262-1.041-.262-1.508 0l-7.752 4.177c-.18.1-.29.287-.29.489s.11.389.29.489z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fill: "#4ACEA5",
    fillRule: "nonzero",
    d: "M248.801 138.673l4.203 2.299c.47.26 1.043.26 1.512 0l7.751-4.177c.18-.1.29-.287.29-.49 0-.201-.11-.388-.29-.488l-4.187-2.29c-.467-.262-1.042-.262-1.509 0l-7.751 4.177c-.177.098-.288.28-.292.479-.004.2.1.385.273.49z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fill: "#0C53FA",
    fillRule: "nonzero",
    d: "M0.114 7.325L20.8 19.055 33.956 11.799 13.27 0.072z",
    opacity: 0.4,
    transform: "translate(233.194 169.12)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fill: "#FBFCFF",
    fillRule: "nonzero",
    d: "M233.307 164.718L253.994 176.445 267.149 169.193 246.463 157.466z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#prefix__t)",
    fillRule: "nonzero",
    d: "M233.307 164.718L253.994 176.445 246.371 154.291 225.682 142.564z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    stroke: "#FFF",
    strokeLinejoin: "round",
    d: "M267.149 169.193L267.149 180.835M254.086 176.92L254.086 188.563M233.307 164.727L233.307 176.37"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fill: "#FBFCFF",
    fillRule: "nonzero",
    d: "M63.042 176.403L40.11 162.022 43.824 160.053 66.757 174.435z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#prefix__u)",
    fillRule: "nonzero",
    d: "M62.971 193.58L62.971 176.397 40.11 162.022 40.11 179.234z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#prefix__v)",
    fillRule: "nonzero",
    d: "M66.757 174.435L66.757 191.305 62.971 193.58 62.971 176.397z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fill: "#FBFCFF",
    fillRule: "nonzero",
    d: "M17.411 162.768L13.626 160.378 37.053 148.754 40.838 151.143z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#prefix__w)",
    fillRule: "nonzero",
    d: "M19.464 184.356L17.341 162.762 13.626 160.378 15.746 182.003z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#prefix__x)",
    fillRule: "nonzero",
    d: "M40.838 151.143L42.958 172.428 19.464 184.356 17.341 162.762z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fill: "#F2F3F4",
    fillRule: "nonzero",
    d: "M39.477 201.9L19.451 189.27 19.451 184.356 39.477 196.98z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fill: "#FBFCFF",
    fillRule: "nonzero",
    d: "M39.477 196.98L19.451 184.347 42.958 172.428 62.987 185.057z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#prefix__y)",
    fillRule: "nonzero",
    d: "M62.987 189.969L39.477 201.891 39.477 196.98 62.987 185.057z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fill: "#FBFCFF",
    fillRule: "nonzero",
    d: "M35.762 190.585L12.83 176.204 16.545 174.236 39.477 188.617z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#prefix__z)",
    fillRule: "nonzero",
    d: "M35.692 207.762L35.692 190.579 12.83 176.204 12.83 193.417z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#prefix__v)",
    fillRule: "nonzero",
    d: "M39.477 188.617L39.477 205.487 35.692 207.762 35.692 190.579z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fill: "#0C53FA",
    fillRule: "nonzero",
    d: "M0.141 17.457L49.425 45.398 80.767 28.116 31.48 0.178z",
    opacity: 0.4,
    transform: "translate(286.038 172.731)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fill: "#FBFCFF",
    fillRule: "nonzero",
    d: "M286.18 168.35L335.464 196.291 366.805 179.009 317.518 151.071z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeLinecap: "round",
    d: "M366.805 179.009L366.805 200.218M335.713 196.354L335.713 217.56M286.18 168.362L286.18 189.571"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#prefix__A)",
    fillRule: "nonzero",
    d: "M324.67 171.32l8.069 4.568c.467.262 1.04.262 1.508 0l4.523-2.491c.18-.1.29-.287.29-.49 0-.202-.11-.388-.29-.488l-8.056-4.569c-.47-.26-1.043-.26-1.512 0l-4.52 2.492c-.18.098-.293.283-.296.486-.002.202.106.39.284.492z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#prefix__B)",
    fillRule: "nonzero",
    d: "M330.72 163.668L336.204 166.897 336.204 172.909 330.72 169.68z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fill: "#4ACEA5",
    fillRule: "nonzero",
    d: "M320.698 156.885v-16.482c.002-.746.618-1.35 1.38-1.351.246 0 .488.065.7.19l21.408 12.395c1.262.733 2.037 2.062 2.04 3.5v16.526l-25.528-14.778z"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M322.077 139.202c.217.003.429.06.615.169l21.414 12.395c1.215.708 1.961 1.989 1.964 3.373v16.25l-25.222-14.604v-16.382c0-.665.55-1.204 1.23-1.204m0-.3c-.849 0-1.537.673-1.537 1.504v16.55l25.618 14.834.218.072v-16.72c.002-1.492-.802-2.873-2.114-3.632l-21.411-12.395c-.236-.137-.504-.21-.778-.21l.003-.004z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#prefix__C)",
    fillRule: "nonzero",
    d: "M344.07 174.766l-21.412-12.395c-1.311-.76-2.115-2.14-2.114-3.633v-1.769l25.618 14.833.218.072v1.6c-.003.538-.299 1.033-.775 1.3-.477.265-1.062.263-1.536-.008z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#prefix__D)",
    fillRule: "nonzero",
    d: "M312.97 175.082l12.502 7.195c.468.262 1.042.262 1.509 0l4.52-2.495c.179-.1.29-.287.29-.489s-.111-.389-.29-.489l-12.496-7.186c-.467-.262-1.041-.262-1.509 0l-4.519 2.495c-.176.1-.284.283-.285.483-.002.199.105.383.279.486z"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    fill: "#0C53FA",
    fillRule: "nonzero",
    d: "M0.141 7.535L20.831 19.262 33.984 12.01 13.297 0.28z",
    opacity: 0.4,
    transform: "translate(286.038 198.31)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fill: "#FBFCFF",
    fillRule: "nonzero",
    d: "M286.18 194.118L306.869 205.845 320.022 198.59 299.336 186.863z"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#prefix__E)",
    fillRule: "nonzero",
    d: "M286.18 194.118L306.869 205.845 299.243 183.688 278.554 171.961z"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    stroke: "#FFF",
    strokeLinejoin: "round",
    d: "M320.022 198.593L320.022 210.236M306.958 206.318L306.958 217.961M286.18 194.127L286.18 205.77"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    fill: "#FBFCFF",
    fillRule: "nonzero",
    d: "M204.24 79.363l50.386 27.685c.766.417 1.7.407 2.456-.025.756-.433 1.224-1.223 1.231-2.081V57.477L204.24 27.75v51.612z"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#prefix__F)",
    fillRule: "nonzero",
    d: "M200.485 28.227L259.677 60.766 259.677 55.879 200.485 23.34z"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#prefix__G)",
    fillRule: "nonzero",
    d: "M200.23 77.398l54.845 30.15c.673.371 1.497.365 2.163-.018.667-.382 1.076-1.082 1.075-1.839 0-.77-.423-1.481-1.109-1.86l-54.845-30.15c-.672-.368-1.494-.361-2.16.02-.665.38-1.075 1.077-1.078 1.831-.004.774.42 1.488 1.109 1.866z"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 256.734,
    cy: 105.872,
    fill: "#D3DAF0",
    fillRule: "nonzero",
    rx: 1.393,
    ry: 1,
    transform: "rotate(-64.42 256.734 105.872)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#prefix__H)",
    fillRule: "nonzero",
    d: "M198.506 29.196L257.699 61.735 257.699 56.848 198.506 24.306z"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#prefix__I)",
    fillRule: "nonzero",
    d: "M259.677 60.766L257.699 61.735 257.699 56.848 259.677 55.879z"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    fill: "#FBFCFF",
    fillRule: "nonzero",
    d: "M259.677 55.879L257.699 56.848 198.506 24.306 200.485 23.34z"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    stroke: "#A9B3CE",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M202.51 31.396L202.51 53.55"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1.979,
    height: 16.057,
    x: 201.517,
    y: 52.238,
    fill: "url(#prefix__J)",
    fillRule: "nonzero",
    rx: 0.989,
    transform: "rotate(180 202.507 60.266)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    stroke: "#A9B3CE",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M255.858 58.196L254.009 57.179M202.181 28.639L200.626 27.784M229.273 43.664L227.424 42.647"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    fill: "#FBFCFF",
    fillRule: "nonzero",
    d: "M128.505 198.063L150.832 210.72 182.069 192.424 159.745 179.767z"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#prefix__K)",
    fillRule: "nonzero",
    d: "M148.233 198.166L156.544 202.875 168.176 196.065 159.865 191.353z"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#prefix__L)",
    fillRule: "nonzero",
    d: "M182.069 192.424L182.069 215.033 150.832 233.329 150.832 210.72z"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#prefix__M)",
    fillRule: "nonzero",
    d: "M128.505 198.063L128.505 220.672 150.832 233.329 150.832 210.72z"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    fill: "#0C53FA",
    fillRule: "nonzero",
    d: "M182.07 141.559v35.509c-.004 1.687-.908 3.25-2.385 4.12l-40.927 23.977c-.54.32-1.215.329-1.764.025-.55-.304-.889-.875-.888-1.493v-35.51c.003-1.689.909-3.253 2.388-4.122l40.933-23.975c.54-.317 1.211-.325 1.758-.02.547.304.885.872.884 1.489z"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    fill: "#9BB3FB",
    fillRule: "nonzero",
    d: "M167.352 170.023v9.895c0 .606-.326 1.168-.857 1.48l-14.72 8.628c-.192.122-.438.13-.638.019-.2-.11-.32-.321-.31-.546v-9.894c-.002-.607.324-1.17.856-1.48l14.71-8.62c.194-.115.436-.12.634-.014.198.108.322.31.325.532z"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    stroke: "#6A8AEB",
    strokeLinecap: "round",
    d: "M159.091 197.116L159.091 180.17"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    fill: "#4ACEA5",
    fillRule: "nonzero",
    d: "M144.285 70.76L132.85 77.07 132.85 56.848 144.285 50.538z"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    fill: "#38AF87",
    fillRule: "nonzero",
    d: "M129.538 66.89L118.099 73.2 118.099 52.978 129.538 46.668z"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M84.331 113.103L32.097 140.951 32.097 101.641 84.331 73.793zM157.598 51.844L146.162 58.154 146.162 37.932 157.598 31.621z"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    stroke: "#FFF",
    strokeLinejoin: "round",
    d: "M214.649 205.695L214.649 214.699M234.008 216.73L234.008 225.737M256.544 204.726L256.544 213.73"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    fill: "#FBFCFF",
    fillRule: "nonzero",
    d: "M232.72 217.269l-18.84-11.496c-.205-.125-.328-.346-.324-.583.004-.236.134-.454.343-.572l21.663-12.176c.827-.466 1.85-.443 2.655.06l18.56 11.622c.201.127.32.348.315.582-.006.235-.135.45-.343.568L235.35 217.31c-.818.46-1.828.444-2.63-.042z"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#prefix__N)",
    fillRule: "nonzero",
    d: "M343.332 139.121L300.242 115.056 311.358 108.902 354.445 132.967z"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#prefix__O)",
    fillRule: "nonzero",
    d: "M343.332 139.121L343.341 140.307 354.445 134.099 354.445 132.967z"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#prefix__P)",
    fillRule: "nonzero",
    d: "M343.332 139.172L343.332 139.121 300.242 115.056 300.242 116.248 301.333 116.856 343.341 140.307 343.341 139.178z"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#prefix__Q)",
    fillRule: "nonzero",
    d: "M343.332 121.49L300.242 97.425 311.358 91.271 354.448 115.336z"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#prefix__R)",
    fillRule: "nonzero",
    d: "M343.332 121.49L343.341 122.675 354.448 116.464 354.448 115.336z"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#prefix__P)",
    fillRule: "nonzero",
    d: "M343.332 121.541L343.332 121.49 300.242 97.425 300.242 98.616 301.333 99.221 343.341 122.675 343.341 121.547z"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    fill: "#FBFCFF",
    fillRule: "nonzero",
    d: "M312.823 90.979L319.512 87.043 317.162 85.797 310.473 89.733z"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    fill: "#0C53FA",
    fillRule: "nonzero",
    d: "M312.866 101.842L312.866 90.976 319.512 87.043 319.512 97.93z"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    fill: "#6A8AEB",
    fillRule: "nonzero",
    d: "M310.473 89.733L310.473 100.404 312.866 101.842 312.866 90.976z"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    fill: "#FBFCFF",
    fillRule: "nonzero",
    d: "M316.894 93.462L323.583 89.525 321.232 88.28 314.544 92.216z"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    fill: "#38AF87",
    fillRule: "nonzero",
    d: "M316.937 104.325L316.937 93.459 323.583 89.525 323.583 100.413z"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    fill: "#4ACEA5",
    fillRule: "nonzero",
    d: "M314.544 92.216L314.544 102.887 316.937 104.325 316.937 93.459z"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    fill: "#FBFCFF",
    fillRule: "nonzero",
    d: "M321.835 96.435L328.523 92.499 326.173 91.253 319.484 95.189z"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    fill: "#0C53FA",
    fillRule: "nonzero",
    d: "M321.878 107.301L321.878 96.432 328.523 92.499 328.523 103.386z"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    fill: "#6A8AEB",
    fillRule: "nonzero",
    d: "M319.484 95.189L319.484 105.863 321.878 107.301 321.878 96.432z"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#prefix__S)",
    fillRule: "nonzero",
    d: "M182.324 73.57h-5.287l.921 2.194c.123.602.851 1.056 1.736 1.056s1.616-.46 1.74-1.056h.018l.872-2.194z"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 179.694,
    cy: 73.26,
    fill: "#6A8AEB",
    fillRule: "nonzero",
    rx: 2.694,
    ry: 1.89
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    fill: "#FBFCFF",
    fillRule: "nonzero",
    d: "M325.906 98.917L332.594 94.981 330.244 93.735 323.555 97.672z"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    fill: "#38AF87",
    fillRule: "nonzero",
    d: "M325.949 109.784L325.949 98.914 332.594 94.981 332.594 105.869z"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    fill: "#4ACEA5",
    fillRule: "nonzero",
    d: "M323.555 97.672L323.555 108.345 325.949 109.784 325.949 98.914z"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    fill: "#FBFCFF",
    fillRule: "nonzero",
    d: "M223.632 195.683L230.321 191.747 227.97 190.501 221.282 194.437z"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    fill: "#38AF87",
    fillRule: "nonzero",
    d: "M223.675 206.55L223.675 195.68 230.321 191.747 230.321 202.634z"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    fill: "#4ACEA5",
    fillRule: "nonzero",
    d: "M221.282 194.437L221.282 205.111 223.675 206.55 223.675 195.68z"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    fill: "#FBFCFF",
    fillRule: "nonzero",
    d: "M229.163 197.022L234.456 191.407 231.842 190.856 226.551 196.472z"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    fill: "#0C53FA",
    fillRule: "nonzero",
    d: "M232.318 207.44L229.206 197.007 234.456 191.407 237.575 201.855z"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    fill: "#6A8AEB",
    fillRule: "nonzero",
    d: "M226.551 196.472L229.608 206.715 232.318 207.44 229.206 197.007z"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    fill: "#38AF87",
    fillRule: "nonzero",
    d: "M179.694 73.603l-10.907-9s10.191-1.968 10.907 9z"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    fill: "#6CEAC0",
    fillRule: "nonzero",
    d: "M172.302 59.19l7.392 14.413s.72-12.795-7.392-14.414z"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    fill: "#38AF87",
    fillRule: "nonzero",
    d: "M179.713 73.603l10.91-9s-10.195-1.968-10.91 9z"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    fill: "#4ACEA5",
    fillRule: "nonzero",
    d: "M179.713 73.603s-.72-12.795 7.392-14.414l-7.392 14.414"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    stroke: "#4ACEA5",
    d: "M32.097 127.683s11.116-1.366 13.574-7.917c2.458-6.552 9.37-23.271 17.3-13.265 9.832 12.386 4.916-16.359 21.36-25.386M208.381 40.017L219.248 45.735M208.381 43.487L219.248 49.204M208.381 46.944L213.816 49.803M241.381 80.167L252.248 85.884M241.381 83.636L252.248 89.354M241.381 87.094L246.813 89.953"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    d: "M134.724 60.194L142.528 55.662M134.724 63.029L142.528 58.494M134.724 65.978L142.528 61.446"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M124.084 65.244L121.992 66.396 121.992 62.701 124.084 61.548zM126.772 63.844L124.68 64.997 124.68 59.018 126.772 57.862z"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    d: "M121.992 55.632L126.772 53.077M121.992 57.663L126.772 55.112"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    fill: "#0C53FA",
    fillRule: "nonzero",
    d: "M134.74 96.97l4.202 2.3c.47.26 1.043.26 1.512 0l7.751-4.177c.18-.101.29-.288.29-.49 0-.203-.11-.39-.29-.491l-4.206-2.3c-.468-.258-1.04-.258-1.508 0l-7.746 4.183c-.178.1-.29.285-.29.486-.002.201.107.388.284.49z"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    fill: "#4ACEA5",
    fillRule: "nonzero",
    d: "M347.658 115.128l-4.203 2.302c-.469.26-1.043.26-1.512 0l-7.751-4.174c-.18-.1-.29-.286-.29-.489 0-.202.11-.388.29-.489l4.206-2.299c.467-.262 1.041-.262 1.508 0l7.752 4.174c.178.1.288.287.288.488 0 .2-.11.387-.288.487z"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    stroke: "#6A8AEB",
    d: "M32.097 132.407s4.67-16.445 9.122-13.207c4.452 3.238 13.055 8.88 18.788-1.466 5.733-10.346 9.429-23.364 17.316-20.863 7.886 2.5 2.86-6.127 7.008-8.333"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    fill: "#0C53FA",
    fillRule: "nonzero",
    d: "M276.296 129.825L271.196 126.928 271.196 113.064 276.296 115.962z"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    fill: "#0C53FA",
    fillRule: "nonzero",
    d: "M5.367 16.795L0.27 13.9 0.27 0.036 5.367 2.931z",
    opacity: 0.2,
    transform: "translate(327.516 144.444)"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    fill: "#0C53FA",
    fillRule: "nonzero",
    d: "M5.171 16.897L0.074 13.999 0.074 0.135 5.171 3.03z",
    opacity: 0.2,
    transform: "translate(333.968 148.056)"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    fill: "#4ACEA5",
    fillRule: "nonzero",
    d: "M282.806 126.013L277.706 123.118 277.706 116.877 282.806 119.772z"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    fill: "#FBFCFF",
    fillRule: "nonzero",
    d: "M282.806 133.563L277.706 130.665 277.706 125.026 282.806 127.921zM289.449 129.627L284.349 126.732 284.349 120.488 289.449 123.386z"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    fill: "#0C53FA",
    fillRule: "nonzero",
    d: "M5.254 8.682L0.154 5.784 0.154 0.144 5.254 3.039z",
    opacity: 0.2,
    transform: "translate(284.195 128.495)"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    fill: "#4ACEA5",
    fillRule: "nonzero",
    d: "M155.158 109.302L161.045 105.878 155.158 102.48z"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    fill: "#6A8AEB",
    fillRule: "nonzero",
    d: "M181.504 108.258L187.39 104.837 181.504 101.439z"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    fill: "#0C53FA",
    fillRule: "nonzero",
    d: "M247.08 69.514l3.46-3.936c-1.536-2.75-3.822-4.36-5.779-3.798-2.516.722-3.518 4.773-2.237 9.043 1.281 4.27 4.357 7.147 6.873 6.425 2.185-.63 3.226-3.759 2.63-7.364l-4.946-.37z"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    fill: "#4ACEA5",
    fillRule: "nonzero",
    d: "M252.027 69.887c-.25-1.506-.752-2.961-1.487-4.306l-3.46 3.933 4.947.373z"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    stroke: "#4ACEA5",
    d: "M148.288 40.092L155.355 36.253"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    fill: "#0C53FA",
    fillRule: "nonzero",
    d: "M178.779 0.262L0.255 102.285 100.301 158.04 122.892 158.04 196.592 115.363 267.411 155.564 290.002 155.564 374.375 107.566z",
    opacity: 0.2
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    stroke: "#4ACEA5",
    d: "M148.288 42.701L155.355 38.859M149.465 49.517s-1.229 4.415-1.638 3.762c-.408-.653.664-1.956 2.766-1.405 2.101.55 4.3-3.16 3.072-2.658"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    stroke: "#DEE5FC",
    d: "M219.899 55.548L219.899 62.523 225.506 65.605 225.506 58.768zM227.927 60.047L227.927 67.022 233.538 70.104 233.538 63.267zM219.899 65.012L219.899 71.987 225.506 75.069 225.506 68.232zM227.927 69.511L227.927 76.486 233.538 79.568 233.538 72.731z"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    stroke: "#4ACEA5",
    strokeWidth: 2,
    d: "M229.273 63.938L230.398 66.396 235.16 62.659"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    fill: "#0C53FA",
    fillRule: "nonzero",
    d: "M0.258 0.271L0.258 93.829 100.304 149.587 100.304 56.026z",
    opacity: 0.2,
    transform: "translate(.922 102.014)"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    fill: "#0C53FA",
    fillRule: "nonzero",
    d: "M0.27 0.193L0.27 93.75 71.282 134.108 71.282 40.547z",
    opacity: 0.2,
    transform: "translate(197.247 114.954)"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M0.144 0.054H22.735V93.61200000000001H0.144z",
    opacity: 0.05,
    transform: "translate(101.081 157.986)"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M0.194 0.232H22.785V93.79H0.194z",
    opacity: 0.05,
    transform: "translate(268.526 155.579)"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    fill: "#0C53FA",
    fillRule: "nonzero",
    d: "M0 42.786L73.7 0.108 73.7 93.45 0 136.347z",
    opacity: 0.2,
    transform: "translate(123.817 115.255)"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    fill: "#0C53FA",
    fillRule: "nonzero",
    d: "M0.298 48.07L84.653 0.027 84.653 93.431 0.298 141.631z",
    opacity: 0.2,
    transform: "translate(290.647 107.43)"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    fill: "#0C53FA",
    fillRule: "nonzero",
    d: "M22.001 113.873L22.001 12.443 0.27 0.108 0.27 101.999z",
    opacity: 0.2,
    transform: "translate(197.247 115.255)"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M179.703.262L1.18 102.285 101.226 158.04 123.817 158.04 197.517 115.363 268.335 155.564 290.927 155.564 375.3 107.566zM13.626 160.378L15.15 175.003 12.83 176.204 12.83 193.417 35.692 207.762 39.477 205.487 39.477 201.9 59.804 191.654 62.971 193.58 66.757 191.305 66.757 174.435 43.824 160.053 41.778 160.86 40.838 151.143 37.053 148.754z"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M198.506 24.309v4.88l2.898 1.593V73.26s-2.114.383-2.114 1.535c0 1.153-.166 1.806.94 2.603l55.284 30.427s2.068.147 2.8-1.445V61.434l1.363-.668v-4.887l-59.192-32.54-1.979.97zM276.539 170.818L299.243 183.688 300.472 187.441 320.544 198.59 320.544 210.236 306.31 218.638 284.905 206.321 284.905 194.127zM267.672 107.828L267.672 131.67 276.01 136.575 276.01 138.45 270.465 141.796 280.588 147.55 287.67 143.509 293.507 146.689 293.507 122.675zM126.772 125.026L126.772 96.495 174.004 70.116M186.294 69.517L194.564 74.094 194.564 104.56 142.021 133.966M136.112 166.12L136.112 206.55 149.035 199.147 155.877 203.266 168.176 196.065 161.751 192.424 182.853 179.767 182.853 138.26z"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAboutSc, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/about-sc.d6b3d60e.svg";
export { ForwardRef as ReactComponent };